export function enterpriseSeatsValidator(value: number) {
  if (value < 1) {
    return 'An enterprise must have 1 or more seats.';
  }
  return undefined;
}
